import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormDetail } from "../../../../../redux/slice/form";
import { useHookForm } from "../../../../../components/hooks";

import {
  FormInputtextarea,
  FormCheckbox,
} from "../../../../../components/formElement";
import {
  option_control_type_less,
  option_control_undo,
} from "../../../../../service/option";

import ImgQuestion from "../../../../../images/other/question_icon.PNG";

import { Button } from "primereact/button";

export default function ModuleControlStep5(props) {
  const { onTabChange } = props;
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  // 表單欄位預設值
  const defaultValues = {
    d1: [],
    d2: [],
    d3: "",
  };
  const { handleSubmit, getValues, reset, yup, setSchema, setting } =
    useHookForm({
      defaultValues,
    });

  useEffect(() => {
    setSchema(
      yup
        .object({
          d1: yup
            .array()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return value.length > 0 || data.d2.length > 0;
              }
            ),
          d2: yup
            .array()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return value.length > 0 || data.d1.length > 0;
              }
            ),
          d3: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return data.d2.indexOf(3) === -1 || value;
              }
            ),
        })
        .required()
    );
  }, []);

  useEffect(() => {
    if (redux_form.formDetail?.step5) {
      reset(redux_form.formDetail.step5);
    }
  }, [redux_form]);

  const onSubmit = (submitData) => {
    let jsonData = {
      ...redux_form.formDetail,
      step5: submitData,
    };
    dispatch(setFormDetail(jsonData));

    onTabChange({ index: 5 });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="text-lg">
        <div className="flex align-items-center text-2xl font-bold mb-1">
          <img className="mr-2" src={ImgQuestion} alt="Question" />
          您現在確認好配戴哪一種眼鏡了嗎？
        </div>
        <div className="ml-2">
          <div className="text-lg font-bold mb-1">已經決定 (複選)</div>
          <div className="flex flex-column">
            {option_control_type_less.map((item) => (
              <FormCheckbox
                key={`control_type_${item.value}`}
                setting={setting}
                data={{
                  name: "d1",
                  label: item.label,
                  type: "multi",
                  value: item.value,
                  disabled: getValues("d2")?.length > 0,
                  isWrap: true,
                }}
              />
            ))}
          </div>

          <div className="text-lg font-bold mt-3 mb-1">尚未決定 (複選)</div>
          <div className="flex flex-column">
            {option_control_undo.map((item) => (
              <FormCheckbox
                key={`control_type_undo_${item.value}`}
                setting={setting}
                data={{
                  name: "d2",
                  label: item.label,
                  type: "multi",
                  value: item.value,
                  disabled: getValues("d1")?.length > 0,
                  isWrap: true,
                }}
              />
            ))}
          </div>

          {getValues("d2")?.indexOf(3) !== -1 && (
            <FormInputtextarea
              className="w-full md:w-8"
              setting={setting}
              data={{
                name: "d3",
                disabled: getValues("d1")?.length > 0,
              }}
            />
          )}
        </div>

        <div className="col-12 text-center my-3">
          <Button
            className="p-button-warning text-white px-3 rotate-icon-x-180"
            type="button"
            label="上一步：了解"
            icon="fa fa-reply bg-main border-round-md p-1"
            onClick={() => onTabChange({ index: 3 })}
          />
          <Button
            className="p-button-warning text-white ml-3 px-3 rotate-icon-xy-180 rotate-icon-y-180"
            type="submit"
            label="下一步：提交"
            icon="fa fa-reply bg-main border-round-md p-1"
          />
        </div>
      </form>
    </>
  );
}
